import { FC } from "react";

interface IconProps {
  color?: string;
}

const Search: FC<IconProps> = ({ color = "#130F26" }) => (
  <svg viewBox="0 0 16 16" stroke={color} xmlns="http://www.w3.org/2000/svg">
    <circle
      cx="7.844"
      cy="7.844"
      r="5.992"
      fill="none"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="m12.012 12.323 2.35 2.344"
      fill="none"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Search;
